var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.775 11.475L5.15 7.85C5.1 7.8 5.0625 7.74583 5.0375 7.6875C5.0125 7.62917 5 7.56667 5 7.5C5 7.36667 5.04583 7.25 5.1375 7.15C5.22917 7.05 5.35 7 5.5 7H13.1C13.25 7 13.3708 7.05 13.4625 7.15C13.5542 7.25 13.6 7.36667 13.6 7.5C13.6 7.53333 13.55 7.65 13.45 7.85L9.825 11.475C9.74167 11.5583 9.65833 11.6167 9.575 11.65C9.49167 11.6833 9.4 11.7 9.3 11.7C9.2 11.7 9.10833 11.6833 9.025 11.65C8.94167 11.6167 8.85833 11.5583 8.775 11.475Z",
    fill: "#627487"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown18);
export default __webpack_public_path__ + "static/media/dropdown_18.c56f1b681520e4dca99a0076c306c88e.svg";
export { ForwardRef as ReactComponent };